export function getLocalePrefix(): string {
  return window.Shopify?.routes?.root?.toString().replace(/^\//, '') || '';
}
